import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "./_redux/Actions";
import helperFunc from "../../../_metronic/_helpers/helperFunc";
import moment from "moment-timezone";
export default function PopupNotification() {
    // const dispatch = useDispatch();
    // const [showNotification, setShowNotification] = useState(false);
    // const [notifyData, setNotifyData] = useState(false);
    // useEffect(() => {
    //     // if (helperFunc.getUserType() !== 'SA') {
    //     function getAlerts() {
    //         dispatch(actions.getContestForRP());
    //     }
    //     getAlerts()
    //     const interval = setInterval(() => getAlerts(), 50000)
    //     return () => {
    //         clearInterval(interval);
    //     }
    //     // }
    // }, []);

    // const { currentState } = useSelector(
    //     (state) => ({ currentState: state.popupNotifications }),
    //     shallowEqual
    // );
    // const { entities } = currentState;

    // useEffect(() => {
    //     if (entities != undefined) {

    //         if (entities && entities.length > 0) {
    //             const data = entities;
    //             setNotifyData(data);
    //             setShowNotification(true);
    //         } else {
    //             setShowNotification(false);
    //         }
    //     }
    // }, [entities]);
    // const redirectTOcontest = (item) => {
    //     if (item && item.event) {
    //         window.open(`${window.location.origin}/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/contests/view/${item._id}`, '_blank');
    //     } else {
    //         if(item && item.isScheduledByb2b) {
    //             window.open(`${window.location.origin}/${process.env.REACT_APP_PUBLIC_URL_SFIX}partner-contests/view/${item._id}`, '_blank');
    //         } else {
    //             window.open(`${window.location.origin}/${process.env.REACT_APP_PUBLIC_URL_SFIX}contests/view/${item._id}`, '_blank');
    //         }
            
    //     }
    // }

    // return (
    //     <>
    //         <Modal show={showNotification} centered onHide={() => setShowNotification(false)}>
    //             <Modal.Header closeButton>
    //                 <Modal.Title>ROOM ID PASSWORD ALERT</Modal.Title>
    //             </Modal.Header>
    //             <Modal.Body>
    //                 {notifyData && notifyData.length > 0 && notifyData.map((item, ind) =>
    //                     <div key={`notify-data-contest${ind}`} className="col-md-12 p-0 text-center mb-10">
    //                         <div className="h2 text-danger">Please Add RoomId / Password for</div>
    //                         <div className="col-md-12 mt-10 text-left">
    //                             <ul className="list-group">
    //                                 <li className="list-group-item">Contest : <span className="text-primary">{item && item.title}&nbsp;( {item && item._id} )</span></li>
    //                                 {item && item.event && (
    //                                     <li className="list-group-item">Tournaments : <span className="text-primary">{item && item.event && item.event.title}</span></li>
    //                                 )}
    //                                 <li className="list-group-item">Date & Time : <span className="text-primary">{item && item.date && moment(item.date).format('ll')} {item && item.time && moment(item.time).format('hh mm A')}</span></li>
    //                                 <li className="list-group-item">Game : <span className="text-primary">{item && item.game && item.game.name}</span></li>
    //                                 <li className="list-group-item">Game Type : <span className="text-primary">{item && item.gameType && item.gameType.name}</span></li>
    //                                 <li className="list-group-item">No of Plyers : <span className="text-primary">{item && (item.userCount || item.totalPlayers)}</span></li>
    //                             </ul>
    //                         </div>
    //                         <div className="col-md-12 mt-10">
    //                             <button type="button" onClick={() => redirectTOcontest(item)} className="btn btn-primary btn-block" >Add RoomId / Password</button>
    //                             <button type="button" onClick={() => setShowNotification(false)} className="btn btn-danger btn-block" >Hide</button>
    //                         </div>
    //                     </div>
    //                 )}

    //             </Modal.Body>
    //         </Modal>
    //     </>
    // );
}
